import { render, staticRenderFns } from "./DeleteItemTypeModal.vue?vue&type=template&id=5656f05d&scoped=true&class=fill-height&"
import script from "./DeleteItemTypeModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteItemTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteItemTypeModal.vue?vue&type=style&index=0&id=5656f05d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656f05d",
  null
  
)

export default component.exports